import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-cream-dark py-16 border-y border-gold-main/10" data-id="element-132" data-mp="1o2vfqkp72f4g">
      <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-133" data-mp="223oe5gim9ucu">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="flex flex-col items-center space-y-6" data-id="element-134" data-mp="22127rk7gpkw7">
          <div className="w-16 h-16 rounded-full bg-cream-light flex items-center justify-center shadow-sm border border-gold-main/20" data-id="element-135" data-mp="1j5vaud42ziex">
            <ShieldCheck className="w-8 h-8 text-gold-main" data-id="element-136" data-mp="qo9eu62xqqek" />
          </div>

          <h2 className="text-2xl md:text-3xl font-playfair font-bold text-brown-dark" data-id="element-137" data-mp="qm6lbc2kqf53">
            Garantía de Satisfacción
          </h2>

          <div className="space-y-4 font-lora text-brown-light text-lg" data-id="element-138" data-mp="p0b8nz95nghj">
            <p data-id="element-139" data-mp="tymgk4fw3gx4">Sabemos que los libros digitales pueden generar dudas.</p>
            <p className="font-medium text-brown-dark" data-id="element-140" data-mp="twrtajh5bcpv">
              Por eso tienes una garantía simple:
            </p>
            <p data-id="element-141" data-mp="12qwt3se9byhj">
              Si compras el ebook y sientes que no aporta valor a tu vida,
              puedes solicitar la devolución de tu dinero dentro de los primeros
              7 días.
            </p>
            <p className="italic text-gold-dark pt-2" data-id="element-142" data-mp="azgx57qt8zen">Sin preguntas.</p>
          </div>
        </motion.div>
      </div>
    </section>;
}